import React, { useEffect, useState } from "react";
import API from "../../services";
import { toast } from "react-toastify";
import { fetchUserIp } from "../../constants/common";
import { useNavigate } from "react-router-dom";
import "./PlayGame.scss";
import { refreshAuthToken } from "../../hooks/hook";
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";

const Fantasy: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [iframeLoading, setIframeLoading] = useState<boolean>(true);
  const [gameSrc, setGameSrc] = useState<string | null>(null);
  const [hasError, setHasError] = useState<boolean>(false);
  const navigate = useNavigate();

  const getGameUrl = async (userIp: string) => {
    setLoading(true);
    let response;
    try {
      response = await API.post(`/webapp/get-login-url`, {
        userKey: sessionStorage.getItem("userKey"),
        tgProviderId: "st01",
        // gameId: "525027",
        clientIp: userIp,
      });
    } catch (e) {
      setLoading(false);
      setHasError(true);
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errorDescription);
      setLoading(false);
      setHasError(true);
      return;
    }

    if (response) {
      const sessionUrl = response.data?.sessionUrl;
      if (!sessionUrl || sessionUrl === "") {
        toast.error("Please try again later");
        setLoading(false);
        setHasError(true);
        return;
      }
      const iframeUrl = buildIframeUrl(sessionUrl);
      setGameSrc(iframeUrl);
      setIframeLoading(true);
    }
    setLoading(false);
  };

  const buildIframeUrl = (sessionUrl: string) => {
    // force a reload even if the base URL doesn't change (common when reusing same session)
    const sep = sessionUrl.includes("?") ? "&" : "?";
    return `${sessionUrl}${sep}launch_as_native_app=true&_ts=${Date.now()}`;
  };

  const initialize = async () => {
    setHasError(false);
    const userIp = await fetchUserIp();
    if (userIp) {
      getGameUrl(userIp);
    } else {
      toast.error("Failed to get user IP");
      setLoading(false);
      setHasError(true);
    }
  };

  // const handleBackClick = () => {
  //   const path = sessionStorage.getItem("previousPath");
  //   if (path) {
  //     navigate(path);
  //   } else {
  //     navigate("/home");
  //   }
  // };

  useEffect(() => {
    const tg = window?.Telegram?.WebApp;
    tg?.expand();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      refreshAuthToken();
    }, 60 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    initialize();
  }, []);

  return (
    <div
      className="w-full fixed gameScreen"
      style={{
        top: '3.75rem',
        bottom: '3.5rem', // Footer height padding
        height: 'auto',
        zIndex: 0,
      }}
    >
      {/* Full-bleed on mobile; constrain only on desktop for the "mobile frame" look */}
      <div className="w-full h-full contentsafearea md:flex md:justify-center">
        {gameSrc && (
          <div className="w-full h-full md:max-w-[26rem] md:rounded-2xl overflow-hidden md:shadow-2xl bg-black/10">
            <iframe
              src={gameSrc}
              title="Fantasy"
              allowFullScreen
              className="w-full h-full z-[1]"
              style={{ height: '100%' }}
              sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
              onLoad={() => {
                setIframeLoading(false);
              }}
            />
          </div>
        )}
        {hasError && !loading && (
          <div className="flex flex-col justify-center items-center min-h-[92vh] fixed inset-0 bg-black bg-opacity-50 z-[10] gap-4">
            <p className="text-white text-lg">Something went wrong</p>
            <button
              className="px-6 py-2 bg-white text-black rounded-lg font-semibold"
              onClick={() => initialize()}
            >
              Retry
            </button>
          </div>
        )}
        {(loading || iframeLoading) && !hasError && (
          <div className="flex justify-center items-center min-h-[92vh] fixed inset-0 bg-black bg-opacity-50 z-[10]">
            <img src={`/${Loader(domain)}`} alt="Loading..." style={{ height: '10rem', width: 'auto' }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Fantasy;
